module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iIwef"))).then(() => parcelRequire('d0iPb'));